// import React from 'react';


// export default function template(context) {
//     const calc = context.calc,
//         model = calc.state.model,

//         sumOrient = (
//             <>
//                 <div>{(model.getMinSumEdge()).toLocaleString('RU-ru') + ' ' + calc.l10n('UAH_ICON')}</div>
//                 <div>{(model.getMaxSumEdge() / 2).toLocaleString('RU-ru') + ' ' + calc.l10n('UAH_ICON')}</div>
//                 <div>{(model.getMaxSumEdge()).toLocaleString('RU-ru') + ' ' + calc.l10n('UAH_ICON')}</div>
//             </>
//         ),
//         shopTermOrient = (
//             <>
//                 <div>{(model.getMinTermEdge())}</div>
//                 <div>{(model.getMinTermEdge() * 6.5)}</div>
//                 <div>{(model.getMaxTermEdge())}</div>
//             </>
//         ),
//         desieredTermsumOrient = (
//             <>
//                 <div>{(model.getMinTermEdge())}</div>
//                 <div>{(model.getMinTermEdge() * 6.5)}</div>
//                 <div>{(model.getMaxTermEdge())}</div>
//             </>
//         );



//     return (
//         <React.Fragment>
//             <div className="calculator-controllers">
//                 <div className="calc-title">{calc.l10n('CREDIT_INSTALLMENT_CALC')}</div>
//                 <div className="controller-block">
//                     <div className="calc-block-title">
//                         {calc.l10n('CREDIT_PBP_SUM')}
//                     </div>
//                     <div className="calculator-slider-wrapper">
//                         <div className="calculator-input-wrapper">
//                             <input name="creditSum" type="text"
//                                    className="calculator-slider-value"
//                                    value={model.getCreditSum().toLocaleString('RU-ru')}
//                                    onChange={calc.handleChangeInput}
//                                    onBlur={calc.blurChangeInput}
//                                    max={model.getMaxSumEdge()}
//                                    min={model.getMinSumEdge()}>
//                             </input>
//                             <span ref={calc.hiddenValue} className='hidden-value'>{model.getCreditSum().toLocaleString('RU-ru')}</span>
//                             <span style={{left: `${calc.state.valueWith + 10}px`}}>{calc.l10n('UAH_ICON')}</span>
//                         </div>
//                         <input type="range"
//                                name="creditSum"
//                                className="calculator-sum-slide"
//                                onChange={calc.handleChange}
//                                value={model.getCreditSum()}
//                                min={model.getMinSumEdge()}
//                                max={model.getMaxSumEdge()}
//                                step={model.getSumStep()}
//                                style={{background: `linear-gradient(90deg, #00D352 ${calc.state.rangePercent}%, rgba(13, 12, 34, 0.1) ${calc.state.rangePercent}%)`}}
//                         />

//                     </div>
//                     <div className="calculator-slider-orient">
//                         {sumOrient}
//                     </div>
//                 </div>

//                 <div className="controller-block">
//                     <div className="calc-block-title">
//                         {calc.l10n('CREDIT_PBP_SHOP_PAYMENTS')}
//                     </div>
//                     <div className="calculator-slider-wrapper">
//                         <div className="calculator-input-wrapper">
//                             <input name="shopCreditTerm" type="text"
//                                    className="calculator-slider-value"
//                                    value={model.getCreditTerm()}
//                                    // onChange={calc.handleChangeInput}
//                                    readOnly ={true}
//                                    min={model.getMinTermEdge()}
//                                    max={model.getMaxTermEdge()}
//                             >
//                             </input>
//                         </div>
//                         <input type="range"
//                                name="shopCreditTerm"
//                                className="calculator-sum-slide"
//                                onChange={calc.handleChange1}
//                                value={model.getCreditTerm()}
//                                min={model.getMinTermEdge()}
//                                max={model.getMaxTermEdge()}
//                                step="1"
//                                style={{ background: `linear-gradient(90deg, #00D352 ${calc.state.rangePercent1}%, rgba(13, 12, 34, 0.1) ${calc.state.rangePercent1}%)` }}
//                         />

//                     </div>
//                     <div className="calculator-slider-orient">
//                         {shopTermOrient}
//                     </div>
//                 </div>

//                 <div className="controller-block">
//                     <div className="calc-block-title">
//                         {calc.l10n('CREDIT_PBP_DESIERED_PAYMENTS')}
//                     </div>
//                     <div className="calculator-slider-wrapper">
//                         <div className="calculator-input-wrapper">
//                             <input name="bankCreditTerm" type="text"
//                                    className="calculator-slider-value"
//                                    value={model.getBankCreditTerm()}
//                                    readOnly ={true}
//                                    min={model.getMinTermEdge()}
//                                    max={model.getMaxTermEdge()}
//                             >
//                             </input>
//                         </div>
//                         <input type="range"
//                                name="bankCreditTerm"
//                                className="calculator-sum-slide"
//                                onChange={calc.handleChange2}
//                                value={model.getBankCreditTerm()}
//                                min={model.getMinTermEdge()}
//                                max={model.getMaxTermEdge()}
//                                step="1"
//                                style={{background: `linear-gradient(90deg, #00D352 ${calc.state.rangePercent2}%, rgba(13, 12, 34, 0.1) ${calc.state.rangePercent2}%)`}}
//                         />
//                     </div>
//                     <div className="calculator-slider-orient">
//                         {desieredTermsumOrient}
//                     </div>
//                     <div className="controller-block-prescription">
//                         {model.getBankCreditTerm() > model.getCreditTerm()
//                             ? calc.l10n('CREDIT_PBP_BANK_TERM_BIGGER')
//                             : ''}
//                     </div>
//                 </div>
//             </div>

//             {/*<div className="calculator-controllers">*/}
//             {/*    <div className="controller-block ">*/}
//             {/*        <div className="calc-block-title">{calc.l10n('CALCULATOR_CREDIT_SUM')}</div>*/}
//             {/*        <div className="calculator-slider-wrapper">*/}
//             {/*            <div className="calculator-slider-value">*/}
//             {/*                <input*/}
//             {/*                    className="calculator-sum-value"*/}
//             {/*                    type="text"*/}
//             {/*                    name="creditSum"*/}
//             {/*                    className="calculator-sum-slide"*/}
//             {/*                    onChange={calc.handleManualInput}*/}
//             {/*                    value={model.getCreditSum()}*/}
//             {/*                    max={model.getMaxSumEdge()}*/}
//             {/*                /> {calc.l10n('CALCULATOR_UAH')}*/}
//             {/*            </div>*/}
//             {/*            <div className="calculator-slider">*/}
//             {/*                <input*/}
//             {/*                    type="range"*/}
//             {/*                    name="creditSum"*/}
//             {/*                    className="calculator-sum-slide"*/}
//             {/*                    onChange={calc.handleChange}*/}
//             {/*                    value={model.getCreditSum()}*/}
//             {/*                    min={model.getMinSumEdge()}*/}
//             {/*                    max={model.getMaxSumEdge()}*/}
//             {/*                    step={model.getSumStep()}*/}
//             {/*                />*/}
//             {/*            </div>*/}
//             {/*        </div>*/}
//             {/*    </div>*/}

//             {/*    <div className="controller-block">*/}
//             {/*        <div className="calc-block-title">{calc.l10n('CREDIT_PBP_SHOP_PAYMENTS')}</div>*/}
//             {/*        <div className="calculator-slider-wrapper">*/}
//             {/*            <div className="calculator-slider-value">{model.getCreditTerm()}</div>*/}
//             {/*            <div className="calculator-slider">*/}
//             {/*                <input*/}
//             {/*                    type="range"*/}
//             {/*                    name="shopCreditTerm"*/}
//             {/*                    className="calculator-sum-slide"*/}
//             {/*                    onChange={calc.handleChange}*/}
//             {/*                    value={model.getCreditTerm()}*/}
//             {/*                    min={model.getMinTermEdge()}*/}
//             {/*                    max={model.getMaxTermEdge()}*/}
//             {/*                    step="1"*/}
//             {/*                />*/}
//             {/*            </div>*/}
//             {/*        </div>*/}
//             {/*    </div>*/}
//             {/*    <div className="controller-block">*/}
//             {/*        <div className="calc-block-title">*/}
//             {/*            {calc.l10n('CREDIT_PBP_DESIERED_PAYMENTS')}*/}
//             {/*        </div>*/}
//             {/*        <div className="calculator-slider-wrapper">*/}
//             {/*            <div className="calculator-slider-value">{model.getBankCreditTerm()}</div>*/}
//             {/*            <div className="calculator-slider">*/}
//             {/*                <input*/}
//             {/*                    type="range"*/}
//             {/*                    name="bankCreditTerm"*/}
//             {/*                    className="calculator-sum-slide"*/}
//             {/*                    onChange={calc.handleChange}*/}
//             {/*                    value={model.getBankCreditTerm()}*/}
//             {/*                    min={model.getMinTermEdge()}*/}
//             {/*                    max={model.getMaxTermEdge()}*/}
//             {/*                    step="1"*/}
//             {/*                />*/}
//             {/*            </div>*/}
//             {/*        </div>*/}
//             {/*        <div className="controller-block-prescription">*/}
//             {/*            {model.getBankCreditTerm() > model.getCreditTerm()*/}
//             {/*                ? calc.l10n('CREDIT_PBP_BANK_TERM_BIGGER')*/}
//             {/*                : ''}*/}
//             {/*        </div>*/}
//             {/*    </div>*/}
//             {/*</div>*/}
//         </React.Fragment>
//     );
// }

import React from 'react';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
        isMobile = calc.isViewportMobile(),

        amountBtns = (
          <div className="calculator-amount-wrapper">
            {['300', '100000', '200000'].map((item, index) => {
              return (
                <button className={`amount-btn ${+item === Number(model.getCreditSum()) ? 'active' : ''}`} name="creditSum" key={index} onClick={calc.handleChange} value={item}>
                  {(+item).toLocaleString() + ' ' + calc.l10n('UAH_ICON')}
                </button>
              )
            })}
          </div>
        ),
        termBtns1 = (
          <div className="calculator-terms-wrapper">
            {[2, 13, 25].map((item, index) => {
              return (
                <button className={`term-btn ${item === Number(model.getCreditTerm()) ? 'active' : ''}`} name="shopCreditTerm" key={item} onClick={calc.handleChange1} data-min={model.getMinTermEdge()} data-max={model.getMaxTermEdge()} value={item}>{item}</button>
              )
            })}
          </div>
        ),
        termBtns2 = (
          <div className="calculator-terms-wrapper">
            {[2, 13, 25].map((item, index) => {
              return (
                <button className={`term-btn ${item === Number(model.getBankCreditTerm()) ? 'active' : ''}`} name="bankCreditTerm" key={item} onClick={calc.handleChange2} data-min={model.getMinTermEdge()} data-max={model.getMaxTermEdge()} value={item}>{item}</button>
              )
            })}
          </div>
        ),
        error = calc.state.error
        ? (<div className="error-text">{`${calc.l10n("CALCULATOR_CREDIT_ERROR_TEXT")} ${model.getMinSumEdge()} ${calc.l10n('UAH_ICON')}`}</div>)
        : '';



    return (
        <React.Fragment>
            <div className="calculator-controllers">
                <div className="calc-title">{calc.l10n('CREDIT_INSTALLMENT_CALC')}</div>
                <div className="calc-mode-description">
                  {calc.l10n("INSTALLMENT_FROM_STATEMENT_CALC_SUBTITLE_1")}
                  <div className="green">{model.getBasicRate() + calc.l10n("PERCENT")}</div>
                </div>
                <div className={`controller-block ${calc.state.error ? 'error' : ''}`}>
                    <div className="calc-block-title">
                      {calc.l10n('CREDIT_PBP_SUM')}
                      {isMobile ? <br/> : ''}
                      <span className="calc-block-title-sum">
                      {` (${calc.l10n('CALCULATOR_CREDIT_SUM_FROM')} ${model.getMinSumEdge()} ${calc.l10n('CALCULATOR_CREDIT_SUM_TO')} ${model.getMaxSumEdge().toLocaleString()} ${calc.l10n('UAH_ICON')})`}
                    </span>
                    </div>
                    <div className="calculator-slider-wrapper">
                        <div className="calculator-input-wrapper">
                            <input name="creditSum" type="text"
                                   className="calculator-slider-value"
                                   value={model.getCreditSum().toLocaleString('uk-UA')}
                                   onChange={calc.handleChangeInput}
                                   onBlur={calc.blurChangeInput}
                                   max={model.getMaxSumEdge()}
                                   min={model.getMinSumEdge()}>
                            </input>
                            <span ref={calc.hiddenValue} className='hidden-value'>{model.getCreditSum().toLocaleString('uk-UA')}</span>
                            <span style={{left: `${calc.state.valueWith}px`}}>{calc.l10n('UAH_ICON')}</span>
                        </div>

                    </div>
                    <input type="range"
                               name="creditSum"
                               className="calculator-sum-slide"
                               onChange={calc.handleChange}
                               value={model.getCreditSum()}
                               min={model.getMinSumEdge()}
                               max={model.getMaxSumEdge()}
                               step={model.getSumStep()}
                              style={{background: `linear-gradient(90deg, #4BDF7F ${calc.state.rangePercent}%, transparent ${calc.state.rangePercent}%)`}}
                        />
                </div>
                {error}
                {amountBtns}
                <div className="controller-block">
                    <div className="calc-block-title">
                        {calc.l10n('CREDIT_PBP_SHOP_PAYMENTS')}
                    </div>
                    <div className="calculator-slider-wrapper">
                        <div className="calculator-input-wrapper">
                            <input name="shopCreditTerm" type="text"
                                   className="calculator-slider-value"
                                   value={model.getCreditTerm()}
                                   // onChange={calc.handleChangeInput}
                                   readOnly ={true}
                                   min={model.getMinTermEdge()}
                                   max={model.getMaxTermEdge()}
                            >
                            </input>
                        </div>
                    </div>
                    <input type="range"
                               name="shopCreditTerm"
                               className="calculator-sum-slide"
                               onChange={calc.handleChange1}
                               value={model.getCreditTerm()}
                               min={model.getMinTermEdge()}
                               max={model.getMaxTermEdge()}
                               step="1"
                               style={{background: `linear-gradient(90deg, #4BDF7F ${calc.state.rangePercent1}%, transparent ${calc.state.rangePercent1}%)`}}
                        />
                </div>
                {termBtns1}
                <div className="controller-block">
                    <div className="calc-block-title">
                        {calc.l10n('CREDIT_PBP_DESIERED_PAYMENTS')}
                    </div>
                    <div className="calculator-slider-wrapper">
                        <div className="calculator-input-wrapper">
                            <input name="bankCreditTerm" type="text"
                                   className="calculator-slider-value"
                                   value={model.getBankCreditTerm()}
                                   readOnly ={true}
                                   min={model.getMinTermEdge()}
                                   max={model.getMaxTermEdge()}
                            >
                            </input>
                        </div>
                    </div>
                    <input type="range"
                               name="bankCreditTerm"
                               className="calculator-sum-slide"
                               onChange={calc.handleChange2}
                               value={model.getBankCreditTerm()}
                               min={model.getMinTermEdge()}
                               max={model.getMaxTermEdge()}
                               step="1"
                               style={{background: `linear-gradient(90deg, #4BDF7F ${calc.state.rangePercent2}%, transparent ${calc.state.rangePercent2}%)`}}
                        />
                </div>
                {termBtns2}
            </div>
        </React.Fragment>
    );
}